export default "__VITE_ASSET__D__zZe6k__"